import { personFrag } from '../../../../../services/types/person.types';
import { serviceUserFrag } from '../../../../../services/types/user.types';
import { serviceMedicalProcedureGridItemFrag } from '../../../../../services/types/service.types';
import { workDataFrag } from '../../../service/types/work.types';

export const voucherPrescribedMedicalProcedureFrag = `
    id
    code
    voucherId
    voucher {
        id
        folderId
        sequenceNumber
        type
        validTo
        closureDate
        issueDate
        doctor {
            icpOfDoctor
        }
    }
    serviceMedicalProcedureId
    serviceMedicalProcedure {
        ${serviceMedicalProcedureGridItemFrag}
    }
    canBeBilled
    canBeBilledWeekend
    canBeBilledNight
    continuousOperation
    courseDescription
    recordTemplate
    usualNumberOfApplications
    frequency
`;

export const performedProcedureFrag = `
    applications
    code
    diagnosis {
        code
        name
        parentName
    }
    voucherPrescribedMedicalProcedureId
    voucherPrescribedMedicalProcedure {
        ${voucherPrescribedMedicalProcedureFrag}
    }
    serviceMedicalProcedureId
    serviceMedicalProcedure {
        ${serviceMedicalProcedureGridItemFrag}
    }
`;

export const workGridItemFrag = `
    id
    dateFrom
    dateTo
    folderId
    serviceId
    person {
        ${personFrag}
    }
    users {
        ${serviceUserFrag}
    }
    workType
    isBilled
    ${workDataFrag}
    files {
        fileId
        name
        path
    }
    performedProcedures {
        ${performedProcedureFrag}
    }
    folderFormData {
        folderForm {
            form {
                uniqueIdentifier
            }
        }
    }
    folderMedications {
        id
    }
`;
